import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { Subscription, timer } from 'rxjs';
import { MessageDialogComponent } from 'src/app/components/message-dialog/message-dialog.component';
import { LocalStorage } from 'src/app/enums/local-storage-key.enum';
import { STATUS } from 'src/app/enums/status.enum';
import { UserModel } from 'src/app/models/user';
import { DataService } from 'src/app/services/data.service';
import { LoadingService } from 'src/app/services/loading.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { PaymentService } from 'src/app/services/payment.service';
import { UserService } from 'src/app/services/user.service';
import { fadeOp } from 'src/app/util/animations.util';


@Component({
  selector: 'app-authorized',
  templateUrl: './authorized.component.html',
  styleUrls: ['./authorized.component.css'],
  animations: [
    fadeOp
  ]
})
export class AuthorizedComponent implements OnInit, OnDestroy {
  mySelf: UserModel = {} as UserModel;
  timeout: Subscription;
  AE_SUPPORT= "support@angkorenterprise.gov.kh";
  resource: string | SafeResourceUrl = "/assets/img/default-pic.webp";

  constructor(
    private user: UserService,
    private dataService: DataService,
    private paymentService: PaymentService,
    private loadingService: LoadingService,
    private localStorage: LocalStorageService,
    private dialog: MatDialog,
    private navService: NavigationService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // this.dataService.getNationalities();
    // this.dataService.getGroupAge();
    this.user.getSelf()
    .subscribe({
      next: resposne => {
        if (resposne.status != STATUS.SUCCESS) return;
        this.mySelf = resposne.data.user;
        this.user.setUser(this.mySelf);
        this.getImageProfile();
      },
      error: console.error
    });
    this.initializeRefreshToken();
    // this.dataService.getUserImage();
    this.paymentService.init();
  }

  markMenuClick(path: string) {
    this.navService.setMenuClicked(true, path);
  }

  logout(): void {
    this.user.logout();
  }

  initializeRefreshToken(): void {
    const expireTime = Number(this.localStorage.get(LocalStorage.expiry_time)) * 1000; // SERVER USE SECOND & FRONTEND USE MILLISECOND * 1000 CHANGE SECOND TO MILLISECOND;
    const timeToLoadDialog = expireTime - (Date.now() + 15000 * 60); //Date.now() - 15 * 60; // BEFORE 15 MN OF EXPIRED TIME;
    if (timeToLoadDialog < 1) {
      this.logout();
      return;
    }
    this.timeout = timer(timeToLoadDialog).subscribe(() => {
      this.onAlertConfirmRefreshToken();
    });
  }

  onAlertConfirmRefreshToken(): void {
    this.dialog.open(MessageDialogComponent, {
      width: '500px',
      disableClose: true,
      data: {
        is_expired_token: true
      }
    })
    .afterClosed()
    .subscribe(response => {
      if (!response) {
        this.user.logout();
        return
      }
      this.loadingService._setLoading();
      this.user.getNewToken()
      .subscribe({
        next: response => {
          if (response.status != STATUS.SUCCESS) {
            this.user.logout();
            return;
          }
          this.initializeRefreshToken();
        },
        complete: () => {
          this.loadingService._clearLoading();
        }
      })
    })
  }

  openMailClient(email: string): void {
    const mailtoLink = `mailto:${email}`;
    window.location.href = mailtoLink;
  }

  getImageProfile() {
    if (this.user.me.avatar) {
      this.dataService.getUserImage();
    } else {
      this.resource =  "/assets/img/default-pic.webp";
    }
  }

  get self(): UserModel {
    return this.user.me || {} as UserModel;
  }

  get isLoading(): boolean {
    return this.loadingService.isLoading;
  }
  _googlePlay(): void {
    window.open("https://play.google.com/store/apps/details?id=com.angkor_pass.app", "_blank");
  }

  _appStore(): void {
    window.open("https://apps.apple.com/us/app/angkor-pass/id6698859997", "_blank");
  }
  ngOnDestroy(): void {
    this.dataService.userImage = null;
    this.timeout?.unsubscribe();
  }
}
